var map = {
	"./01_Goetsch_OnBothEnds_Ausstellungsansicht.webp": 7713,
	"./06_Goetsch_Untitled_Ausstellungsansicht.webp": 8375,
	"./08_Goetsch_CandyLover(F)_CandyLover(A)_Ausstellungsansicht.webp": 7936,
	"./09_Goetsch_Zwischenbilanzen_Ausstellungsansicht.webp": 8238,
	"./12_Goetsch_LoopingLessons.webp": 8934,
	"./15_Goetsch_WaitingForYouWaitingForMe.webp": 1120
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4443;